module.exports = __webpack_public_path__ + "static/media/alcec2.738c6fab.webp";